import './Footer.css';

import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <div className="footer">
            <footer className="row">
                <div className="col m6 s12 footer-left">
                    <div>
                        © {new Date().getFullYear()} SocietyX
                    <span className="footer_seperator"></span>
                        <Link to="/terms"> Terms of Service</Link>
                        <span className="footer_seperator">·</span>
                        <Link to="/privacy-policy"> Privacy Policy</Link></div>
                </div>
                <div className="col m6 s12 footer-right">
                    <ul>
                        <li><a className="the-icons nav-links extra-links facebook" href="https://www.facebook.com/TheSocietyX" target="_blank"><i className="fa fa-facebook"></i></a></li>
                        <li><a className="the-icons nav-links extra-links twitter" href="https://twitter.com/The_SocietyX" target="_blank"><i className="fa fa-twitter"></i></a></li>
                        <li><a className="the-icons nav-links extra-links instagram" href="https://www.instagram.com/p/B-N9nkYjbuj" target="_blank"><i className="fa fa-instagram"></i></a></li>
                        <li><a className="the-icons nav-links extra-links youtube" href="https://www.youtube.com/channel/UCoSquUmHU6tGuuU5hzKC7cA" target="_blank"><i className="fa fa-youtube-play"></i></a> </li>
                    </ul>
                </div>
            </footer>
        </div>
    )
}

export default Footer
